import { useTranslation } from 'react-i18next';

import { Body1, Stack, Subtitle1 } from '@myphx-engineering/phx-design-system';
import { GrayPillsIllustration } from '@phx/myphx-lib';

export const UpToDateCard = () => {
    const { t } = useTranslation();

    return (
        <Stack align="center" justify="center">
            <GrayPillsIllustration />
            <Subtitle1>{t('cabinet.upToDate.header')}</Subtitle1>
            <Body1 ta="center">{t('cabinet.upToDate.body')}</Body1>
        </Stack>
    );
};
